import React, { useContext, useEffect, useState } from "react";
import { Box, Button, Checkbox, CircularProgress, Dialog, DialogContent, FormControl, FormControlLabel, FormGroup, IconButton, Typography, Fab, List, ListItem, ListItemText, Card, CardContent, InputLabel, MenuItem, Select, TextField, Container, DialogActions, Tabs, Tab, Autocomplete, Divider, Chip } from "@mui/material";
import OpaqueLoading from "../opaqueLoading/opaqueLoading";
import { ArrowBack, Remove, Add, Delete, Discount, ArrowForward } from "@mui/icons-material";
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import DeleteIcon from '@mui/icons-material/Delete';
import { Check as CheckIcon, Clear as ClearIcon, Close, CropSharp, Details } from "@mui/icons-material";
import { CloseOutlined } from "@mui/icons-material";
import styled from "styled-components";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Cart from "../newCart";
import AddOnProductsScreen from "../addOns";
import OrderForm from "../selectionScreen";
import SelectParty from "../selectParty";
const isMobile = window.innerWidth < 900;
const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    width: 75%;
    height: 100vh;
    max-width: none;
    max-height: none;
  }
`;
const TabContainer = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const AddOlympiadSchoolModal = ({ props, onClose1, onClose, remarks, dataProp, id, distributorId, fetchData, status, editMode, partyS, propType }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [employees, setEmployees] = useState([]);
  const [payload, setPayload] = useState({})
  const [getSeriesCategory, setgetSeriesCategory] = useState()
  const [getSpecimenSeries, setGetSpecimenSeries] = useState([])
  const [cart, setCart] = useState([]);
  const [addOncart, setAddOnCart] = useState([]);
  const [className, setClassName] = useState()
  const [filteredClassName, setFilteredClassName] = useState()
  const [medium, setMedium] = useState()
  const [partyType, setPartyType] = useState(partyS)
  const [allProducts, setAllProducts] = useState([]);
  const [selectedParty, setSelectedParty] = useState();
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [owner, setOwner] = useState("")
  const [orderMode, setOrderMode] = useState("")
  const [user, setUSer] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)
  const [mittplusProducts, setMittplusProducts] = useState([]);
  const [productMittplusList, setProductMittplusList] = useState([]);
  const [specimenSeries, setSpecimenSeries] = useState([]);
  const [specimenClasses, setSpecimenClasses] = useState([]);
  const [specimenProducts, setSpecimenProducts] = useState([]);
  const [specimenFilteredClasses, setSpecimenFilteredClasses] = useState([]);
  const [specimenFilteredProducts, setSpecimenFilteredProducts] = useState([]);
  const [seriesWiseClass, setSeriesWiseClass] = useState([]);

  const [productData, setProductData] = useState({
    assignTo: "",
    orderType: propType || "",
    productGroup: "",
    uploadSeries: [],
    series: "",
    class: "",
    medium: "",
    product: [],
    quantity: "",
    discount: "0",
    applyDiscount: "yes",
    orderProcess: "new",
    productType: ""
  });

  useEffect(() => {
    if (!dataProp) return;

    let parsedSeries = [];
    if (dataProp.orderProcess === "upload" && dataProp.uploadSeries) {
      try {
        parsedSeries = Array.isArray(dataProp.uploadSeries)
          ? dataProp.uploadSeries
          : JSON.parse(dataProp.uploadSeries);
      } catch {
        parsedSeries = [];
      }
    }

    setProductData((prev) => ({
      ...prev,
      orderType: dataProp.orderType || "",
      productGroup: dataProp.productGroup || "",
      orderProcess: dataProp.orderProcess || "new",
      uploadSeries: parsedSeries,
    }));
  }, [dataProp]);


  useEffect(() => {
    setCart([]);
    setAddOnCart([]);
    setFilteredProducts([]);
    setSpecimenFilteredClasses([]);
    setSpecimenFilteredProducts([]);
    setFilteredClassName([]);

    setProductData((prev) => ({
      ...prev,
      uploadSeries:
        editMode && prev.orderProcess === "upload"
          ? prev.uploadSeries
          : [],
      series: "",
      class: "",
      product: [],
      quantity: "",
      productType: "",
      applyDiscount: "yes",
    }));
  }, [productData.orderType, editMode, productData?.orderProcess]);

  const getAvailableQty = (product) => {
    if (!product) return 0;
    const keys = ['quantity', 'qty', 'availableQuantity', 'available', 'stock', 'inHand', 'available_qty', 'in_stock', 'totalQuantity'];
    for (const k of keys) {
      if (product[k] !== undefined && product[k] !== null) return Number(product[k]);
    }
    return 0;
  };

  const handleQuantityChange = (index, delta) => {
    let temp = [...cart];
    const current = temp[index] || {};
    const newQty = Math.max(1, current.quantity + delta);

    if (productData.orderType === 'Specimen') {
      const available = getAvailableQty(current.data);
      if (newQty > available) {
        window.NotificationUtils.showError('You Do Not Have Enough Stock');
        return;
      }
    }

    temp[index].quantity = newQty;
    setCart(temp);
  };

  const handleRemoveItem = (index) => {


    let temp = [...cart]
    temp.splice(index, 1)
    setCart(temp)
  };

  function closePopup() {
    fetchData()
    onClose1()
  }

  useEffect(() => {
    getSeriesCategoryData()
    getClass()
    getMedium()
    fetchInitialData();
  }, [])


  useEffect(() => {
    getSpecimenProduct();
    getProductSpecimenInventory();
  }, [owner])

  useEffect(() => {
    if(editMode && productData?.orderType == "Specimen"){
      getProductSpecimenInventory();
    }
  }, [productData?.orderProcess, ])

  // useEffect(() => {
  //   filterProducts();
  // }, [productData.class,]);

  useEffect(() => {
    filterProducts();
  }, [productData.series, productData.class, productData.medium, allProducts]);

  useEffect(() => {
    if (productData.orderType === "Specimen") {
      filterSpecimenProducts();
    }
  }, [productData.series, productData.class]);
useEffect(() => {
  if (!editMode || cart.length === 0) return;

  const uniqueSeriesClass = [];

  cart.forEach((item) => {
    const series = item?.data?.seriesCategory;
    const classId = item?.data?.classId || item?.class;
    const medium = item?.data?.mediumTableId;

    if (!series || !classId) return;

    const exists = uniqueSeriesClass.some(
      (x) =>
        x.series === series &&
        x.class === classId &&
        x.medium === medium
    );

    if (!exists) {
      uniqueSeriesClass.push({
        series,
        class: classId,
        medium,
        productGroup: item?.group,
        orderType: item?.orderType,
      });
    }
  });

  setSeriesWiseClass(uniqueSeriesClass);
}, [cart, editMode]);
  // useEffect(() => {
  //   setCart([]);
  //   setAddOnCart([]);
  //   setFilteredProducts([]);
  //   setSpecimenFilteredClasses([]);
  //   setSpecimenFilteredProducts([]);
  //   setFilteredClassName([]);

  //   setProductData((prev) => ({
  //     ...prev,
  //     uploadSeries: [],
  //     series: "",
  //     class: "",
  //     product: "",
  //     quantity: "",
  //     productType: "",
  //     applyDiscount: "yes",
  //   }));
  // }, [productData.orderType]);

  const getProductSpecimenInventory = async () => {
    try {
      const t = localStorage.getItem("user");
      const id = t ? JSON.parse(t).id : "";
      const body = { user_id: editMode ? dataProp?.ownerId : owner };
      let response = await window.Platform.database.getProductWithSeries(body);
      if (response) {
        let b = [];
        let c = [];
        let d = [];
        for (let i = 0; i < response.data.length; i++) {
          const item = response.data[i];
          const seriesItem = {
            seriesTableId: item.seriesCategory,
            seriesName: item.seriesName
          };
          if (!b.some((x) => x.seriesTableId === seriesItem.seriesTableId)) {
            b.push(seriesItem);
          }
          const classItem = {
            classId: item.classId,
            className: item.className
          };
          if (!c.some((x) => x.classId === classItem.classId)) {
            c.push(classItem);
          }
        }

        // setSpecimenSeries(b);
        if(editMode && dataProp?.orderProcess == "upload"){
      let sel=JSON.parse(dataProp.uploadSeries)
      let filteredSeries=b.filter((ele)=>sel.includes(ele.seriesTableId))
      setSpecimenSeries(filteredSeries);

    }else{
    setSpecimenSeries(b);
    }
        setSpecimenClasses(c);
        setSpecimenProducts(response.data);
      } else {
        throw new Error("Failed to load orders");
      }
    } catch (error) {
      console.log("Error fetching orders:", error);
    } finally {
    }
  };

  const fetchInitialData = async () => {
    const seriesResults = await window.Platform.database.getSeriesCategory();
    // if(editMode && dataProp?.orderProcess == "upload"){
    //   let sel=JSON.parse(dataProp.uploadSeries)
    //   let filteredSeries=seriesResults.data.filter((ele)=>sel.includes(ele.seriesTableId))
    //   setgetSeriesCategory(filteredSeries);

    // }else{
    // setgetSeriesCategory(seriesResults.data);
    // }
 setgetSeriesCategory(seriesResults.data);

    let result12 = await window.Platform.database.fetchProductMittplus();
    setProductMittplusList(result12?.data || []);

    let results = await window.Platform.database.getMittplusProductGroups();
    setMittplusProducts(results?.data || []);

    const filteredSpecimenSeries = await seriesResults?.data?.filter((ele) => String(ele.specimen).toLowerCase() === "true");
    setGetSpecimenSeries(filteredSpecimenSeries);

    const classResults = await window.Platform.database.getClass();
    const classData = classResults?.data?.map((obj, index) => ({
      ...obj,
      id: index + 1,
    }));
    setClassName(classData);

    const mediumResults = await window.Platform.database.getMedium();
    const filteredMedium = mediumResults?.data?.filter(
      (medium) => medium.mediumTableId !== "buCiAvMirI"
    );
    setMedium(filteredMedium);

    const productResults = await window.Platform.database.fetchProduct();
    const productData = productResults?.data?.map((obj, index) => ({
      ...obj,
      id: index + 1,
    }));
    if (editMode) {

      // let obj = {
      //   orderType: dataProp.orderType,
      //   productGroup: productData.productGroup,
      // }

      // setProductData(obj)
      setProductData((prev) => ({
        ...prev,
        orderType: dataProp.orderType,
        productGroup: dataProp.productGroup,
        orderProcess: dataProp.orderProcess || prev.orderProcess
      }));

      editProductData(dataProp?.orderId, productData)
    }
    setAllProducts(productData);
  };

  const getAvailableProducts = () => {
    if (productData.orderType === "Specimen") return specimenFilteredProducts;

    if (productData.productGroup === "6HPipXSLx5") {
      const list = productMittplusList.filter((p) => {
        if (!productData.productType) return true;
        return p.productType === productData.productType;
      });
      return list.map((p) => ({
        skuId: p.id,
        nameSku: p.product_name,
        unitPrice: p.landing_cost || 0,
        original: p
      }));
    }
    return filteredProducts;
  };

  const getSpecimenProduct = async () => {
    try {
      let results = await window.Platform.database.getSpecimenProduct();

      if (results && results.status) {
        // setSpecimenProduct(results.data)
      }
    } catch (error) {
      console.error("ERRORCHECK", error);
    }
  }

  const getSeriesCategoryData = async (data) => {
    let results = await window.Platform.database.getSeriesCategory();
    // setgetSeriesCategory(results.data)
    // if(editMode && dataProp?.orderProcess == "upload"){
    //   let sel=JSON.parse(dataProp.uploadSeries)
    //   let filteredSeries=results.data.filter((ele)=>sel.includes(ele.seriesTableId))
    //   setgetSeriesCategory(filteredSeries);

    // }else{
    // setgetSeriesCategory(results.data);
    // }
    setgetSeriesCategory(results.data);
  }

  const getClass = async (data) => {
    const results = await window.Platform.database.getClass(data);
    const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
    setClassName(jsonArrayWithId)
  }

  const getMedium = async (data) => {
    let results = await window.Platform.database.getMedium();
    const finalData = results?.data?.filter(medium => medium.mediumTableId != "buCiAvMirI")
    setMedium(finalData)
  }

  const filterProducts = () => {
    const filtered = allProducts.filter((product) => {
      const matchesSeries =
        product.seriesCategory === productData.series;
      const matchesClass =
        !productData.class || product.classId === productData.class;
      const matchesMedium =
        !productData.medium || product.mediumTableId === productData.medium;

      return matchesSeries && matchesClass && matchesMedium;
    });
    setFilteredProducts(filtered);
  };

  async function editProductData(val, all) {
    try {
      let sentData = { id: val }
      let d = JSON.parse(dataProp.seriesDiscount)

      if(dataProp?.orderType == "Specimen"){
        
      const body = { user_id: editMode ? dataProp?.ownerId : owner };
      let response = await window.Platform.database.getProductWithSeries(body);
      let results = await window.Platform.database.fetchOrderLineItem(sentData);

      let temp = [...cart]

response.data.forEach((ele) => {
        let p = results.data.filter((s) => { 
          return s.itemId == ele.skuId })[0]
        if (p) {
          if (Object.keys(d).includes(p.seriesCategory)) {
            p.discount = d[p.seriesCategory]
          } else {
            p.discount = 0
          }
          temp.push(
            {
              data: p,
              group: ele?.productGroup,
              quantity: parseInt(ele?.QTY, 10),
              bookType: p && p['type']?.toLowerCase() == 'set' ? 'Choose from Set' : 'Choose from Individual Book',
              orderType: productData?.orderType || "",
              // class: p.class || ""
              class: p.classId || p.class || ""
            })
        }
      })
      setCart(temp)
      }
      else{
      let results = await window.Platform.database.fetchOrderLineItem(sentData);

      let temp = [...cart]
      results.data.forEach((ele) => {
        let p = all.filter((s) => { 
          return s.skuId == ele.itemId })[0]
        if (p) {
          if (Object.keys(d).includes(p.seriesCategory)) {
            p.discount = d[p.seriesCategory]
          } else {
            p.discount = 0
          }
          temp.push(
            {
              data: p,
              group: ele?.productGroup,
              quantity: parseInt(ele?.QTY, 10),
              bookType: p && p['type']?.toLowerCase() == 'set' ? 'Choose from Set' : 'Choose from Individual Book',
              orderType: productData?.orderType || "",
              // class: p.class || ""
              class: p.classId || p.class || ""
            })
        }
      })
      setCart(temp)
      }
     
    
    } catch (e) {
      console.log("ERRORCHECK", e)
    }
  }
  // const handleAddProductToCart = (productData) => {
  //   console.log(productData, "product data", specimenFilteredProducts, filteredProducts, productMittplusList);

  //   const productsToSearch = getAvailableProducts();
  //   const selectedProduct = productsToSearch.find(
  //     (product) => product.skuId === productData.product
  //   );
  //   if (selectedProduct && productData.quantity) {
  //     let temp = [...cart];
  //     let flag = false;
  //     let index;
  //     for (let i = 0; i < temp.length; i++) {
  //       if (temp[i].data.skuId == selectedProduct.skuId) {
  //         flag = true;
  //         index = i;
  //         break;
  //       }
  //     }

  //     const requested = parseInt(productData?.quantity, 10);
  //     const existingQty = flag ? temp[index].quantity : 0;

  //     // For specimen orders, enforce available stock before adding
  //     if (productData.orderType === 'Specimen') {
  //       const available = getAvailableQty(selectedProduct);
  //       if (available === 0) {
  //         window.NotificationUtils.showError('This product has no available stock');
  //         return;
  //       }
  //       if (existingQty + requested > available) {
  //         window.NotificationUtils.showError('You Do Not Have Enough Stock');
  //         return;
  //       }
  //     }

  //     if (!flag) {
  //       temp.push({
  //         data: selectedProduct,
  //         group: productData?.productGroup,
  //         quantity: requested,
  //         bookType: selectedProduct['type'] == 'set' ? 'Choose from Set' : 'Choose from Individual Book',
  //         orderType: productData.orderType || ""
  //       });
  //       index = temp.length - 1;
  //     } else {
  //       temp[index]['quantity'] += requested;
  //     }


  //     setProductData({ ...productData, product: "", quantity: "" });
  //     window.NotificationUtils.showSuccess("Product added successfully");
  //   } else {
  //     window.NotificationUtils.showError("Please select a product and quantity");
  //   }
  // };
const handleAddProductToCart = (productData) => {
  if(!productData.class){
    alert("Please Select Class");
    return;
  }
  const productsToSearch = getAvailableProducts();

  if (!productData.product?.length || !productData.quantity) {
    window.NotificationUtils.showError("Please select product(s) and quantity");
    return;
  }

  let temp = [...cart];
  const requestedQty = parseInt(productData.quantity, 10);
  
  const seriesWiseClassData = {
    series: productData.series,
    class: productData.class,
    medium: productData.medium,
    productGroup: productData.productGroup,
    orderType: productData.orderType
  };
  
  const classExists = seriesWiseClass.some(
    item => item.series === productData.series && item.class === productData.class && item.medium === productData.medium
  );
  
  if (!classExists && productData.series && productData.class) {
    setSeriesWiseClass([...seriesWiseClass, seriesWiseClassData]);
  }

  productData.product.forEach((skuId) => {
    const selectedProduct = productsToSearch.find(
      (product) => product.skuId === skuId
    );
    if (!selectedProduct) return;

    let index = temp.findIndex(
      (item) => item.data.skuId === selectedProduct.skuId
    );

    const existingQty = index > -1 ? temp[index].quantity : 0;

    // ✅ specimen stock check
    if (productData.orderType === "Specimen") {
      const available = getAvailableQty(selectedProduct);
      if (available === 0) {
        window.NotificationUtils.showError(
          `${selectedProduct.nameSku}Product has no available stock`
        );
        return;
      }
      if (existingQty + requestedQty > available) {
        window.NotificationUtils.showError(
          `Not enough stock for ${selectedProduct.nameSku}`
        );
        return;
      }
    }

    if (index > -1) {
      temp[index].quantity += requestedQty;
    } else {
      temp.push({
        data: selectedProduct,
        group: productData.productGroup,
        quantity: requestedQty,
        bookType:
          selectedProduct && selectedProduct?.type?.toLowerCase() === "set"
            ? "Choose from Set"
            : "Choose from Individual Book",
        orderType: productData.orderType || "",
        class:productData.class||""
      });
    }
  });

  setCart(temp);

  // ✅ RESET MUST BE ARRAY
  setProductData({
    ...productData,
    product: [],
    quantity: "",
  });

  window.NotificationUtils.showSuccess("Product(s) added successfully");
};

  function proceedToAddOns(value, body) {
    if (body?.orderType === "Specimen") {
      setPayload(body);
      setAddOnCart([]); // Clear add-on items for Specimen
      setActiveTab(4); // Jump directly to order form
    } else {
      setPayload(body)
      setAddOnCart(value)
      setActiveTab(3) // Show add-ons screen for non-Specimen orders
    }
  }
  function proceedToOrderForm(value) {
    setPayload(value)
    setActiveTab(4)
  }

  function sortClasses(value) {
    if (productData.orderType === "Specimen") {
      const classesInSeries = specimenProducts
        .filter((product) => product.seriesCategory === value)
        .map((product) => product.classId);
      const uniqueClasses = specimenClasses.filter((cls) =>
        classesInSeries.includes(cls.classId)
      );
      setSpecimenFilteredClasses(uniqueClasses);
    } else {
      let pro = allProducts.filter((ele) => { return ele.seriesCategory == value }).map((ele) => ele.classId)
      setFilteredClassName(className.filter((ele) => { return pro.includes(ele.classId) }))
    }
  }

  function filterSpecimenProducts() {
    if (productData.series && productData.class) {
      const filtered = specimenProducts.filter((product) =>
        product.seriesCategory === productData.series &&
        product.classId === productData.class
      );
      setSpecimenFilteredProducts(filtered);
    } else {
      setSpecimenFilteredProducts([]);
    }
  }
  function proceedToCart() {
    if(productData?.orderProcess == "upload" && productData.uploadSeries.length <= 0){
      alert("Select Series");
      return;
    }
    let milliseconds = Date.now()
    let obj = {
      "address": selectedParty['AddressLine1'],
      "addressId": selectedParty['addressId'],
      "approvalStatus": "1",
      // "date": milliseconds,
      "discount": "0",
      "applyDiscount": productData.applyDiscount,
      "email": selectedParty['email'],
      "mobileNo": selectedParty['makerContact'],
      "orderType": productData.orderType,
      "partyId": selectedParty['schoolId'] ? selectedParty['schoolId'] : selectedParty['distributorID'],
      "partyType": partyType.toLowerCase() == 'distributor' ? "P6E9TGXewd" : "cQpLw8vwZf",
      "totalAmount": 0,
      "transport": selectedParty['transporterId'],
      "ownerId": owner,
      "orderMode": orderMode,
      "uploadSeries": productData?.orderProcess == "upload" ? productData.uploadSeries : [],
      "orderProcess": productData?.orderProcess
    };
    setPayload(obj)
    setActiveTab(2)
  }
  function back() {
    setActiveTab(activeTab - 1)
  }

  return (
    <StyledDialog open={true} style={{ width: "106vw" }}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">School Order</Typography>
        <IconButton onClick={onClose}>
          <CloseOutlined />
        </IconButton>
      </Box>
      <Tabs value={activeTab} onChange={(e, newTab) => setActiveTab(newTab)}>
        <Tab label="Select Party" style={{ width: "20%" }} disabled />
        <Tab label="Order Details" style={{ width: "20%" }} disabled />
        <Tab label="My Cart" style={{ width: "20%" }} disabled />
        <Tab label="Add-On Products" style={{ width: "20%" }} disabled />
        <Tab label="Create Order" style={{ width: "20%" }} disabled />
      </Tabs>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, my: 1, ml: 2 }}>
        {activeTab > 0 && (
          <Button variant="outlined" onClick={() => setActiveTab((prev) => Math.max(0, prev - 1))}>
            <ArrowBackIcon sx={{ marginRight: "2px" }} />  Back
          </Button>
        )}
      </Box>
      {activeTab === 0 && (
        <>
          <SelectParty editMode={editMode} back={back} partyId={dataProp ? dataProp.partyId : ""} ownerId={dataProp ? dataProp.ownerId : ""} chooseParty={setSelectedParty} choosePartyType={setPartyType} setTab={setActiveTab} partyType={partyType} setOwner={setOwner} setParentOrderMode={setOrderMode} />
        </>
      )}
      {activeTab === 1 && (
        <div style={{ display: "flex", width: "100%", gap: "20px" }}>
          <div style={{ flex: 1, maxWidth: "50%" }}>
            <TabContainer style={{ width: "100%" }}>
              <FormControl fullWidth sx={{ minWidth: 200, mb: 2 }}>
                <InputLabel>Order Type</InputLabel>
                <Select
                disabled={editMode || propType}
                  label="Order Type"
                  value={productData.orderType}
                  onChange={(e) =>
                    setProductData({ ...productData, orderType: e.target.value })
                  }
                >
                  <MenuItem value="Sales">Booking Confirmation</MenuItem>
                  <MenuItem value="Specimen">Specimen</MenuItem>
                  <MenuItem value="saleS">Sales Booking</MenuItem>
                </Select>
              </FormControl>
              <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel>Product Group</InputLabel>
                <Select
                // disabled={editMode}
                  label="Product Group"
                  value={productData.productGroup}
                  onChange={(e) =>
                    setProductData({ ...productData, productGroup: e.target.value, productType: "", uploadSeries: [], series: "", class: "", product: [] })
                  }
                >
                  <MenuItem value="CttetdmeoW">MittSure</MenuItem>
                  {productData?.orderType != "Specimen" && <MenuItem value="6HPipXSLx5">MittPlus</MenuItem>}
                </Select>
              </FormControl>
              {productData?.productGroup == "6HPipXSLx5" && <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel>Product Type</InputLabel>
                <Select
                // disabled={editMode}
                  label="Product Group"
                  value={productData.productType}
                  onChange={(e) =>
                    setProductData({ ...productData, productType: e.target.value, product: [] })
                  }
                >
                  {mittplusProducts?.map((option) => (
                    <MenuItem key={option.id} value={option.id} > {option.name} </MenuItem>
                  ))}
                </Select>
              </FormControl>}
              {productData?.orderType != "Specimen" && <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel>Discount</InputLabel>
                <Select
                disabled={editMode}
                  label="Discount"
                  value={productData.applyDiscount}
                  onChange={(e) =>
                    setProductData({ ...productData, applyDiscount: e.target.value })
                  }
                >
                  <MenuItem value="yes">Yes</MenuItem>
                  <MenuItem value="no">No</MenuItem>
                </Select>
              </FormControl>}
              <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel>Order Process</InputLabel>
                <Select
                disabled={editMode && productData.orderProcess != "upload"}
                  label="Order Process"
                  value={productData.orderProcess}
                  onChange={(e) =>
                    setProductData({ ...productData, orderProcess: e.target.value })
                  }
                >
                  <MenuItem value="new">Create Order</MenuItem>
                  <MenuItem value="upload">Upload Order</MenuItem>
                </Select>
              </FormControl>
            </TabContainer>
            {productData.orderProcess === "upload" && <>
              <TabContainer>
                {/* <FormControl fullWidth>
                  <InputLabel>Select Series</InputLabel>
                  <Select
                    label="Select Series"
                    multiple   // ✔ MULTI SELECT
                    value={productData.uploadSeries || []}
                    onChange={(e) =>
                      setProductData({ ...productData, uploadSeries: e.target.value })
                    }
                  >
                    {getSeriesCategory?.map((option) => (
                      <MenuItem
                        key={option.seriesTableId}
                        value={option.seriesTableId}
                      >
                        {option.seriesName.toUpperCase()}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl> */}

                <FormControl fullWidth>
                  <InputLabel>Select Series</InputLabel>
                  <Select label="Select Series" multiple value={productData.uploadSeries || []}
                    onChange={(e) =>
                      setProductData({
                        ...productData,
                        uploadSeries: e.target.value
                      })
                    }
                    renderValue={(selected) =>
                      getSeriesCategory
                        ?.filter(item => selected.includes(item.seriesTableId))
                        .map(item => item.seriesName)
                        .join(", ")
                    }
                  >
                    {getSeriesCategory?.map((option) => (
                      <MenuItem
                        key={option.seriesTableId}
                        value={option.seriesTableId}
                      >
                        <Checkbox
                          checked={
                            (productData.uploadSeries || []).indexOf(option.seriesTableId) > -1
                          }
                        />
                        <ListItemText
                          primary={option.seriesName.toUpperCase()}
                        />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

              </TabContainer>
            </>
            }
            {productData.orderProcess !== "upload" &&
              productData.orderType &&
              productData.productGroup && (
                <TabContainer>
                  {productData.productGroup != "6HPipXSLx5" &&
                    <><FormControl fullWidth>
                      <InputLabel>Select Series</InputLabel>
                      <Select
                        label="Select Series"
                        value={productData.series}
                        onChange={(e) => {
                          setProductData({ ...productData, series: e.target.value });
                          sortClasses(e.target.value);
                        }}
                      >
                        {(productData.orderType === "Specimen"
                          // ? getSpecimenSeries
                          ? specimenSeries
                          : getSeriesCategory
                        )?.map((option) => (
                          <MenuItem
                            key={option.seriesTableId}
                            value={option.seriesTableId}
                          >
                            {option.seriesName.toUpperCase()}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                      <FormControl fullWidth>
                        <InputLabel>Class</InputLabel>
                        {productData.orderType === "Specimen" ? <Select
                          label="Class"
                          value={productData.class}
                          onChange={(e) =>
                            setProductData({ ...productData, class: e.target.value })
                          }
                        >
                          {specimenFilteredClasses?.map((option) => (
                            <MenuItem key={option.classId} value={option.classId}>
                              {option.className}
                            </MenuItem>
                          ))}
                        </Select>
                          :
                          <Select
                            label="Class"
                            value={productData.class}
                            onChange={(e) =>
                              setProductData({ ...productData, class: e.target.value })
                            }
                          >
                            {filteredClassName?.map((option) => (
                              <MenuItem key={option.classId} value={option.classId}>
                                {option.className}
                              </MenuItem>
                            ))}
                          </Select>}
                      </FormControl>
                    </>}
                  {/* <FormControl fullWidth>
                    <InputLabel>Product</InputLabel>
                    <Select
                      label="Product"
                      value={productData.product}
                      onChange={(e) =>
                        setProductData({ ...productData, product: e.target.value })
                      }
                    >
                      {getAvailableProducts().map((p) => (
                        <MenuItem key={p.skuId} value={p.skuId}>
                          {p.nameSku}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl> */}
{/* <Autocomplete
  multiple
  disableCloseOnSelect
  options={getAvailableProducts()}
  getOptionLabel={(option) => option.nameSku || ""}
  value={getAvailableProducts().filter(p =>
    productData.product.includes(p.skuId)
  )}
  onChange={(event, newValue) => {
    setProductData({
      ...productData,
      product: newValue.map(item => item.skuId) // store skuIds only
    });
  }}
  renderOption={(props, option, { selected }) => (
    <li {...props}>
      <Checkbox
        icon={<CheckIcon fontSize="small" />}
        checkedIcon={<CheckIcon fontSize="small" />}
        checked={selected}
        sx={{ mr: 1 }}
      />
      {option.nameSku}
    </li>
  )}
  renderTags={(value, getTagProps) =>
    value.map((option, index) => (
      <Chip
        label={option.nameSku}
        {...getTagProps({ index })}
        size="small"
      />
    ))
  }
  renderInput={(params) => (
    <TextField
      {...params}
      label="Product"
      placeholder="Search product"
    />
  )}
/> */}

<Autocomplete
  multiple
  disableCloseOnSelect
  options={getAvailableProducts()}
  // getOptionLabel={(option) => option.nameSku || ""}
  getOptionLabel={(option) =>`${option.nameSku || ""} (${option.sku_code || ""})` }
  value={getAvailableProducts().filter(p =>
    productData.product.includes(p.skuId)
  )}
  onChange={(event, newValue) => {
    setProductData({
      ...productData,
      product: newValue.map(item => item.skuId)
    });
  }}
  // renderOption={(props, option, { selected }) => (
  //   <li {...props}>
  //     <Checkbox
  //       checked={selected}
  //       sx={{ mr: 1 }}
  //     />
  //     {option.nameSku}
  //   </li>
  // )}
  renderOption={(props, option, { selected }) => (
  <li {...props}>
    <Checkbox checked={selected} sx={{ mr: 1 }} />
    {option.nameSku} ({option.sku_code})
  </li>
)}
  // renderTags={(value, getTagProps) =>
  //   value.map((option, index) => (
  //     <Chip
  //       label={option.nameSku}
  //       {...getTagProps({ index })}
  //       size="small"
  //     />
  //   ))
  // }
  renderTags={(value, getTagProps) =>
  value.map((option, index) => (
    <Chip
      label={`${option.nameSku} (${option.sku_code})`}
      {...getTagProps({ index })}
      size="small"
    />
  ))
}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Product"
      placeholder="Search product"
    />
  )}
/>


                  <TextField
                    label="Quantity"
                    type="number"
                    fullWidth
                    value={productData.quantity}
                    onWheel={(e)=>{e.target.blur()}}
                    onChange={(e) =>
                      setProductData({ ...productData, quantity: e.target.value })
                    }
                  />
                </TabContainer>
              )}
            {productData?.orderProcess != "upload" && <Button
              sx={{ ml: 3, mb: 4 }}
              variant="contained"
              color="primary"
              onClick={() => handleAddProductToCart(productData)}
            >
              Add Product
            </Button>}
            {(cart && cart?.length > 0 || productData?.orderProcess === "upload") && <Button
              sx={{ ml: 2, mb: 4 }}
              variant="contained"
              color="success"
              onClick={() => proceedToCart()}
            >
              Next
            </Button>}
          </div>

          {/* RIGHT SIDE CART – HIDE FOR UPLOAD ORDER */}
          {productData.orderProcess !== "upload" && (
            <div style={{ flex: 1, maxWidth: "50%" }}>
              <TabContainer>
                <Typography>Added Products</Typography>

                {cart.length === 0 ? (
                  <Typography sx={{ textAlign: "center", mt: 10 }}>
                    <b>No Product Added Yet</b>
                    {/* {editMode && <OpaqueLoading />} */}
                  </Typography>
                ) : (
                  <List>
                    {cart.map((item, index) => (
                      <Card key={index} sx={{ m: 2, p: 1 }}>
                        <CardContent>
                          <ListItem>
                            {productData?.orderType == "Specimen" ? <ListItemText
                              primary={item.data.nameSku}
                              secondary={`Total Price: ₹ 0.00
                                } | Price: ₹ 0.0`}
                            />
                              :
                              <ListItemText
                                // primary={item.data.nameSku}
                                primary={item?.data?.nameSku && item?.data?.sku_code ? `${item.data.nameSku} (${item.data.sku_code})` : ""}
                                secondary={`Total Price: ₹${(item.data.unitPrice * item.quantity).toFixed(2)
                                  } | Price: ₹${item.data.unitPrice}`}
                              />}
                           {item?.quantity > 0 && <IconButton onClick={() => handleQuantityChange(index, -1)}>
                              <Remove />
                            </IconButton>}

                            {item?.quantity > 0 && <Typography>{item?.quantity ? item?.quantity : 0}</Typography>}

                            {item?.quantity>0 && <IconButton onClick={() => handleQuantityChange(index, 1)}>
                              <Add />
                            </IconButton>}

                            <IconButton
                              onClick={() => handleRemoveItem(index)}
                              color="error"
                            >
                              <Delete />
                            </IconButton>
                          </ListItem>
                        </CardContent>
                      </Card>
                    ))}
                  </List>
                )}
              </TabContainer>
            </div>
          )}
        </div>
      )}

      {activeTab === 2 && (
        <>
          <Cart payload={payload} editMode={editMode} seriesD={dataProp ? dataProp.seriesDiscount : ""} attachments1 = {dataProp ? dataProp?.attachment : []} series={getSeriesCategory} initialCartItems={cart} setCart={setCart} proceed={proceedToAddOns} newDataProp={productData} tntAmount={dataProp ? dataProp?.tentativeAmount : null} isSpecimen={productData?.orderType === "Specimen"}/>
        </>
      )}

      {activeTab === 3 && productData?.orderType !== "Specimen" && (
        <AddOnProductsScreen editMode={editMode} erp={dataProp ? dataProp?.onBoardERP : null} addOnPro={dataProp ? dataProp?.addOnProduct : null} payload={payload} items={addOncart} series={getSeriesCategory} proceed={proceedToOrderForm} seriesWiseClass={seriesWiseClass} />
      )}

      {activeTab === 4 && (
        <OrderForm payload={payload} closePopup={closePopup} editData={dataProp ? dataProp : null} editMode={editMode} getSeriesCategory={getSeriesCategory} />
      )}
    </StyledDialog>
  );
};


export default AddOlympiadSchoolModal;